import { useEffect, useState } from "react";

import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import logger from "../../../../utils/logger";

export const ActionsOnUsers = ({ status, row, handleModal, alert, handleAlertContent, enabled, actionsPack }) => {



    logger.debug('status actions: ', status)
    let actionMock = actionsPack

    // logger.debug('actionMock: ', actionMock.UrlSegment.url)

    //! Funcion para concretar acciones sobre un usuario
    const actionsOnUser = (e, row, obj) => {
        e.stopPropagation() //👉 evita que dispare el click de la fila si hay

        //👉 activar un modal de interrogación
        if (alert) {
            handleModal('alert')
        }

        logger.debug('Actions row: ', { ...row })

        const newRow = { email: row?.email, ...obj, }
        logger.info('new row: ', newRow)
        handleAlertContent(newRow)

    };

    const actionsIcons = (obj, row) => {

        logger.info('row en ActionOnUser: ', row)
        logger.info('obj en ActionOnUser: ', obj)

        // if (obj.hasOwnProperty('Ver')) {
        //     logger.info('si lo tiene ')
        // }

        // logger.debug('OBJETO ES: ',obj)


        return <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${obj?.verb}`}>{obj?.verb}</Tooltip>}
        >

            {obj?.key === 5 ?

                <Link to={`/MemberDetail/${row?.id}`}
                    className={`btn toTooltip-style ${obj?.key === 5 ? 'spanVer' : ''}`}>
                    <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj?.icon}</span>
                </Link>

                :

                <button
                    className={`btn toTooltip-style`}
                    onClick={(e) => actionsOnUser(e, row, obj)}>
                    <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj?.icon}</span>
                </button>
            }




        </OverlayTrigger>
    };

    const renderActionButtons = (status, row) => {
        //? status proveniente de la API
        switch (status) {
            case 'Interested':

                return <>

                    {actionsIcons(actionMock.Rechazar, row)}
                    {actionsIcons(actionMock.Reenviar, row)}
                    {actionsIcons(actionMock.Ver, row)}

                </>
            case 'Pending':
                return <>

                    {actionsIcons(actionMock.Rechazar, row)}
                    {actionsIcons(actionMock.Aprobar, row)}
                    {actionsIcons(actionMock.Ver, row)}

                </>
            case 'Active':
                return (
                    <>

                        {enabled ? (
                            <>
                                {actionsIcons(actionMock.Inhabilitar, row)}
                            </>
                        ) : (
                            <>
                                {actionsIcons(actionMock.Habilitar, row)}
                            </>
                        )}

                        {actionsIcons(actionMock.Ver, row)}

                    </>
                )
            case 'Rejected':
                return <>
                    {actionsIcons(actionMock.Aprobar, row)}
                    {actionsIcons(actionMock.Ver, row)}

                </>
            case 'Expired':
                return <>
                    {actionsIcons(actionMock.Renovar, row)}
                    {actionsIcons(actionMock.Ver, row)}

                </>
            case 'Locked':
                return <>
                    {actionsIcons(actionMock.Habilitar, row)}
                    {actionsIcons(actionMock.Ver, row)}
                </>

            case 'NearFromExpire':
                return <>
                    {actionsIcons(actionMock.Inhabilitar, row)}
                    {actionsIcons(actionMock.Renovar, row)}
                    {actionsIcons(actionMock.Ver, row)}

                </>
            default:
                return <>
                    {actionsIcons(actionMock.Ver, row)}
                </>
                break;
        }
    };



    return (
        <>{renderActionButtons(status, row)}</>
    )
}


